function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".aaa{fill:#f9eec0;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M38.152,8.106a2.083,2.083,0,0,0,1.105.309,2.181,2.181,0,0,0,1.019-.233,2.71,2.71,0,0,0,.766-.577v.355a.467.467,0,0,0,.1.355.514.514,0,0,0,.33.081,2.688,2.688,0,0,0,.629-.071c.2-.048.311-.074.345-.081v-.4h-.619V.142L41.63,0h-.02L39.947.172V.537L41,.639V2.646a4.682,4.682,0,0,0-1.075-.122,2.805,2.805,0,0,0-1.526.411A2.751,2.751,0,0,0,37.391,4.05a3.453,3.453,0,0,0-.355,1.577,3.519,3.519,0,0,0,.3,1.541,2.168,2.168,0,0,0,.811.938Zm.3-4.451a1.74,1.74,0,0,1,1.4-.624,2.525,2.525,0,0,1,.725.1A.712.712,0,0,1,41,3.376V7.107a1.757,1.757,0,0,1-.583.461,1.732,1.732,0,0,1-.826.208,1.5,1.5,0,0,1-1.2-.548,2.552,2.552,0,0,1-.466-1.683,2.876,2.876,0,0,1,.527-1.891Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M45.62,8.415a3.243,3.243,0,0,0,1.131-.208,2.261,2.261,0,0,0,.857-.512l-.162-.375a2.053,2.053,0,0,1-.689.365,2.707,2.707,0,0,1-.872.152,1.567,1.567,0,0,1-1.353-.674,2.921,2.921,0,0,1-.482-1.739h3.61a4.5,4.5,0,0,0,.061-.892,2.193,2.193,0,0,0-.542-1.49,1.866,1.866,0,0,0-1.4-.517,2.47,2.47,0,0,0-1.333.37,2.528,2.528,0,0,0-.928,1.039,3.383,3.383,0,0,0-.334,1.531,3.376,3.376,0,0,0,.634,2.145A2.167,2.167,0,0,0,45.62,8.415Zm-.051-5.373a1.129,1.129,0,0,1,.948.4A1.727,1.727,0,0,1,46.837,4.5a3.13,3.13,0,0,1-.03.446H44.059Q44.18,3.042,45.569,3.042Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M50.524,8.415a2.478,2.478,0,0,0,1.526-.431A1.4,1.4,0,0,0,52.623,6.8a1.315,1.315,0,0,0-.233-.8A1.812,1.812,0,0,0,51.8,5.49a7.552,7.552,0,0,0-.933-.42l-.193-.082a5.494,5.494,0,0,1-.619-.289,1.162,1.162,0,0,1-.375-.339.9.9,0,0,1-.152-.538.682.682,0,0,1,.3-.583,1.325,1.325,0,0,1,.791-.218,2.1,2.1,0,0,1,.634.091.6.6,0,0,1,.36.223l.183.74h.5V2.869a6.62,6.62,0,0,0-.694-.223,3.477,3.477,0,0,0-.867-.092,2.651,2.651,0,0,0-.978.178,1.74,1.74,0,0,0-.72.5,1.156,1.156,0,0,0-.269.761,1.535,1.535,0,0,0,.375,1.085,2.979,2.979,0,0,0,1.2.7,5.134,5.134,0,0,1,1.176.573.806.806,0,0,1,.345.675q0,.912-1.237.912a2.164,2.164,0,0,1-.76-.132.924.924,0,0,1-.466-.3l-.152-.791H48.7V7.989a4.113,4.113,0,0,0,.831.284,4.074,4.074,0,0,0,.993.142Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M54.144,10.21l-.781.1v.446h2.717v-.446l-1.126-.1V9.115l-.02-.862a2.8,2.8,0,0,0,.517.116,4.093,4.093,0,0,0,.6.046A2.728,2.728,0,0,0,57.546,8a2.767,2.767,0,0,0,1.009-1.13,3.521,3.521,0,0,0,.355-1.587A3.452,3.452,0,0,0,58.6,3.731a2.1,2.1,0,0,0-.816-.913,2.151,2.151,0,0,0-1.1-.294,2.267,2.267,0,0,0-1.044.238,2.97,2.97,0,0,0-.791.573V2.717l-.183-.162h-.02l-1.3.162v.457l.791.172Zm.811-6.479a2.044,2.044,0,0,1,.588-.406,1.834,1.834,0,0,1,.811-.182,1.5,1.5,0,0,1,1.2.563,2.578,2.578,0,0,1,.472,1.688,2.925,2.925,0,0,1-.532,1.9,1.732,1.732,0,0,1-1.4.644,2.342,2.342,0,0,1-.725-.106.755.755,0,0,1-.411-.238Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M62.6,7.888l-1.348-.081V3.964a3.7,3.7,0,0,1,.75-.426,2.507,2.507,0,0,1,.984-.173,1.316,1.316,0,0,1,.289.03.553.553,0,0,1,.178.061V2.565a1.1,1.1,0,0,0-.3-.041,2.074,2.074,0,0,0-.989.264,2.569,2.569,0,0,0-.74.553q-.249.289-.269.309h-.02l.02-.77V2.717l-.193-.162h-.02l-1.287.162v.457l.781.172V7.817l-.811.061V8.3H62.6Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M66.486,8.415a3.243,3.243,0,0,0,1.131-.208,2.261,2.261,0,0,0,.857-.512l-.162-.375a2.053,2.053,0,0,1-.689.365,2.706,2.706,0,0,1-.872.152A1.567,1.567,0,0,1,65.4,7.163a2.921,2.921,0,0,1-.482-1.739h3.61a4.5,4.5,0,0,0,.061-.892,2.193,2.193,0,0,0-.542-1.49,1.866,1.866,0,0,0-1.4-.517,2.471,2.471,0,0,0-1.333.37,2.528,2.528,0,0,0-.928,1.039,3.383,3.383,0,0,0-.334,1.531,3.376,3.376,0,0,0,.634,2.145A2.167,2.167,0,0,0,66.486,8.415Zm-.051-5.373a1.129,1.129,0,0,1,.948.4A1.728,1.728,0,0,1,67.7,4.5a3.138,3.138,0,0,1-.03.446H64.925q.122-1.906,1.511-1.906Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M115.871,24.772a3.379,3.379,0,0,1-.444,1.926,2.5,2.5,0,0,1-3.219-.006,3.332,3.332,0,0,1-.45-1.971V21.027l-3.3-.393v4.075a5.268,5.268,0,0,0,1.375,3.929,6.464,6.464,0,0,0,7.915.019,5.267,5.267,0,0,0,1.394-3.872V19.766l-3.276.893Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M128.3,22.979a4.55,4.55,0,0,0,2.338-4.062c.006-.152.013-.3.013-.456a1.678,1.678,0,0,0-.006-.177l-3.276.184c.006.082.006.171.006.26a3.648,3.648,0,0,1-.019.38,2.553,2.553,0,0,1-.469,1.362,1.72,1.72,0,0,1-1.47.653h-1.863V18.689l-.583.032-2.693.735V29.778h3.277V23.853h1.629l2.44,5.925h3.517V29.62Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M86.081,22.757h5.1V20.6l-8.377,1.09v8.092H92.12V27.06H86.081Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M63.857,29.778h3.289V21.9l-3.289.191Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M104.255,20.761l-.2,4.626v4.391h3.283V20.5l-3.048-.362Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M95.713,20.273l-3.048.177v9.328h3.276V25.387l-.2-4.487Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M101.4,19.95l-.165.64-1.223,4.695-1.191-4.562-.165-.615-2.535.146.178.615,2.585,8.909h2.231l2.636-9.074.178-.615-1.616-.19Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M80.092,22.674a3.844,3.844,0,0,0,.792-.741l-4.563.6-4.734-.513v7.763h3.276V23.853h1.622l2.44,5.925H82.45V29.62L79.6,22.979A5.289,5.289,0,0,0,80.092,22.674Z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M56.272,24.772a3.329,3.329,0,0,1-.444,1.926,2.5,2.5,0,0,1-3.219-.006,3.338,3.338,0,0,1-.444-1.971v-3.2l-3.061-.26h-.038l-.2.032v3.416a5.293,5.293,0,0,0,1.375,3.929A5.447,5.447,0,0,0,54.225,30a5.39,5.39,0,0,0,3.929-1.343,5.216,5.216,0,0,0,1.394-3.872V22.142l-3.276-.279Z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M44.593,26.654a2.139,2.139,0,0,1-1.781.627,1.989,1.989,0,0,1-1.857-.9,6.538,6.538,0,0,1-.539-3.042v-.634l-3.283.545c0,.215.006.431.025.634a7.35,7.35,0,0,0,1.439,4.3A5.09,5.09,0,0,0,42.812,30a5.513,5.513,0,0,0,4.056-1.426,6.076,6.076,0,0,0,1.559-4.2H45.151A4.136,4.136,0,0,1,44.593,26.654Z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M122.725,16.325v-2.4h1.914c1.2,0,1.838.722,1.9,2.18l3.276-.184a4.675,4.675,0,0,0-1.337-3.447,5.278,5.278,0,0,0-3.8-1.28h-5.228v5.9l2.693-.735Z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M118.321,11.192h-3.276v7.1l3.276-.894Z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M110.932,11.192h-3.295v7.079l3.295.393Z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M103.1,17.726l.424-1.464-.063,1.508,3.048.361V11.192h-4.277l-1.661,6.394.913-.05Z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M94.817,16.262l.476,1.628,2.535-.145-1.711-6.553H91.839v6.895l3.048-.178Z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M90.356,17.757h-5.1V13.923h6.014V11.192h-9.29v8.131l8.377-1.09Z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M80.059,19.57A5.266,5.266,0,0,0,81.13,16.1a4.744,4.744,0,0,0-1.343-3.625,5.278,5.278,0,0,0-3.8-1.28H70.763v8.46l4.734.513Zm-6.02-5.646h1.914q1.9,0,1.9,2.44a2.8,2.8,0,0,1-.488,1.743,1.713,1.713,0,0,1-1.47.653H74.039Z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M59.09,13.923h3.942v5.805l3.288-.19V13.923h4.012V11.192H59.09Z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M55.446,19.5l3.276.279V11.192H55.446Z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M48.279,18.9l3.061.26V11.192h-3.3V18.93l.2-.032Z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M37.858,20.671l0-.041,1.73-.287V17.631a6.512,6.512,0,0,1,.577-3.023,1.993,1.993,0,0,1,1.863-.919,2.074,2.074,0,0,1,1.774.653,4.381,4.381,0,0,1,.532,2.364H47.62a6.735,6.735,0,0,0-1.565-4.252,5.211,5.211,0,0,0-4.024-1.483,5.17,5.17,0,0,0-4.208,1.812,7.623,7.623,0,0,0-1.5,4.873L36,17.573l-2.052,1.065-1.705-.655.372-7.148L26.236,2.59,22.6,4.565l-3.01.343L18.668,6.38l-1.2-1.463L12.058,3.9l-3.2,2.091L3.27,13.022,0,14.768l4.773,4.459L3.9,21.389l3.388,2.062,2.091-1.424.5.434L8,24.465l3.268,3.1,12.22,1.319,3.947-3.343,6.693,2.71-.207-4,2.357-3.1Zm-4.713,3.344L33.3,27.1l-6.01-2.433-4.049,3.43L11.607,26.836l-2.532-2.4,1.9-2.028-1.54-1.34L7.261,22.544,4.848,21.075l.831-2.047L1.3,14.939l2.4-1.281L9.327,6.592,12.219,4.7l4.833.913,1.7,2.068,1.293-2.059,2.719-.31L26.03,3.572l5.811,7.506-.386,7.42L34,19.473l2.1-1.087.208.055v1.9l-.482.146Z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M27.843,17.55H26.107L25.7,14.921a.337.337,0,0,0-.326-.285.376.376,0,0,0-.337.271l-.963,4.8L23,12.234a.338.338,0,0,0-.668,0L20.9,21.373,19.4,10.108a.338.338,0,0,0-.67,0L17.24,21.373,15.8,12.23a.338.338,0,0,0-.668,0l-1.072,7.474-.963-4.8a.385.385,0,0,0-.343-.27.337.337,0,0,0-.322.285l-.405,2.629H10.293a.225.225,0,0,0-.225.224V18a.225.225,0,0,0,.225.224h2.024a.337.337,0,0,0,.333-.285l.161-1.034.975,4.859a.337.337,0,0,0,.664-.018l1.031-7.192,1.45,9.327a.314.314,0,0,0,.326.284h.01a.34.34,0,0,0,.332-.292L19.066,12.81l1.465,11.061a.338.338,0,0,0,.669.008l1.45-9.326,1.031,7.192a.337.337,0,0,0,.325.289.362.362,0,0,0,.34-.271l.975-4.859.161,1.034a.334.334,0,0,0,.333.285h2.029A.225.225,0,0,0,28.068,18v-.224a.225.225,0,0,0-.225-.224Z"
});

var SvgLogoCutremurFull = function SvgLogoCutremurFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 131.136,
    height: 30.012,
    viewBox: "0 0 131.136 30.012",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoCutremurFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo_Cutremur_Full.a3795e34.svg";
export { ForwardRef as ReactComponent };